/**
 * The shared look of Antonin's catalog (Section 1), behind the `signalLook` switch (`?x=signal-look`).
 * It only sets or removes `data-look="signal"` on the root element. Every rule of
 * `src/styles/showcase-signal.css` is scoped to that attribute, so with the switch off nothing changes.
 */
export function applySignalLook(on: boolean, root: HTMLElement = document.documentElement): void {
  if (on) root.dataset.look = 'signal';
  else delete root.dataset.look;
}
